import {
  itemWithNestingCanDrag,
  itemWithNestingBeginDrag,
  itemWithNestingEndDrag,
  itemWithNestingIsDragging,
  itemWithNestingDrop,
  itemWithNestingHover,
  itemWithNestingCanDrop,
} from 'Shared/utils/DnDSpecs/itemWithNestingDnDSpecs';
import {
  actionItemCanDrag,
  actionItemBeginDrag,
  actionItemEndDrag,
  actionItemIsDragging,
  actionItemDrop,
  actionItemHover,
  actionItemCanDrop,
} from 'Shared/utils/DnDSpecs/itemDnDSpecs.ts';
import pick from 'lodash/pick';
import { dragCollect, dropCollect } from 'Shared/utils/DnDSpecs/defaultDnDSpecs';

const canDrag = props =>
  props.useNestingDnd ? itemWithNestingCanDrag(props.forbidDrag) : actionItemCanDrag(props.forbidDrag);
const beginDrag = props => (props.useNestingDnd ? itemWithNestingBeginDrag(props) : actionItemBeginDrag(props));
const endDrag = (props, monitor, item) =>
  props.useNestingDnd ? itemWithNestingEndDrag(props, monitor, item) : actionItemEndDrag(props, monitor, item);
const isDragging = (props, monitor) =>
  props.useNestingDnd ? itemWithNestingIsDragging(props, monitor) : actionItemIsDragging(props, monitor);
const hover = (props, monitor, item) =>
  props.useNestingDnd ? itemWithNestingHover(props, monitor, item) : actionItemHover(props, monitor, item);
const canDrop = (props, item) =>
  props.useNestingDnd ? itemWithNestingCanDrop(props, item) : actionItemCanDrop(props, item);
const drop = (props, monitor) =>
  props.useNestingDnd ? itemWithNestingDrop(props, monitor) : actionItemDrop(props, monitor);

export const dragSpec = ({ uuid, forbidDrag, useNestingDnd, onDrop, onNestByDrag, dispatch, selector }) => ({
  canDrag: () => canDrag({ forbidDrag, useNestingDnd }),
  begin: () =>
    beginDrag({
      uuid,
      useNestingDnd,
      getState: () => dispatch((_, getState) => getState()),
      selector,
    }),
  end: (dragItem, monitor) => endDrag({ onDrop, onNestByDrag, dispatch, useNestingDnd }, monitor, dragItem),
  isDragging: monitor => isDragging({ uuid, useNestingDnd }, monitor),
  collect: monitor => dragCollect(monitor),
});

export const dropSpec = ({ uuid, containerRef, item, useNestingDnd, setHoverOffset, setIsDropAsChild, isLast }) => ({
  hover: (dragItem, monitor) =>
    hover(
      {
        containerRef,
        useNestingDnd,
        setHoverOffset,
        setIsDropAsChild,
        isLast,
        ...pick(item, ['isHighPriority', 'parentUuid', 'itemType']),
      },
      monitor,
      dragItem
    ),
  canDrop: dragItem =>
    canDrop(
      {
        useNestingDnd,
        ...pick(item, ['uuid', 'isHighPriority', 'parentUuid', 'itemType', 'assignmentPersonId']),
      },
      dragItem
    ),
  drop: (_, monitor) => drop({ uuid, id: item.id, useNestingDnd }, monitor),
  collect: monitor => dropCollect(monitor),
});
